import { server_ip } from "../config"
export async function getNewsTag(){
    try{
        const res = await fetch(`${server_ip}/api/tags/fetch`,{
            method:'POST',
        })
        const json = await res.json()
        return json
    }catch(err){
        return {errno:1, message:'Unexpected Errpr'}
    }
}
export async function getNewsDetail(filter, options){
    try{
        const res = await fetch(`${server_ip}/api/resources/fetch`,{
            method:'POST',
            headers:{
                Accept: 'application/json',
                'content-type':'application/json'
            },
            body: JSON.stringify({filter, options})
        })
        const json = await res.json()
        return json
    }catch(err){
        return {errno:1, message:'Unexpected Errpr'}
    }
}

export async function getNewsFromId(id){
    try{
        const res = await fetch(`${server_ip}/api/resources/${id}`,{
            method:'GET',
            headers:{
                Accept: 'application/json',
            },
        })
        const json = await res.json()
        return json
    }catch(err){
        return {errno:1, message:'Unexpected Errpr'}
    }
}